import {
  BiLogoFacebook,
  BiLogoInstagramAlt,
  BiLogoWhatsapp,
  BiLogoTelegram,
  BiLogoSnapchat,
  BiMap,
} from "react-icons/bi";
import { FaXTwitter } from "react-icons/fa6";
import type { ReactNode } from "react";

export const socialMediaTypes: Record<number, ReactNode> = {
  1: <BiLogoFacebook className="text-lg" />,
  2: <BiLogoInstagramAlt className="text-lg" />,
  3: <BiLogoWhatsapp className="text-lg" />,
  4: <BiLogoTelegram className="text-lg" />,
  5: <BiLogoSnapchat className="text-lg" />,
  6: <FaXTwitter className="text-lg" />,
  7: <BiMap className="text-lg" />,
};
